import React, { InputHTMLAttributes } from 'react'
import Link from 'next/link'
import classNames from 'classnames'
import { useField } from 'formik'

import { FieldError } from '@components/form'

import styles from '../../styles.module.scss'
import { FieldProps } from '@components/form/types'

type InputPasswordProps = FieldProps &
  Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> & {
    showLinkForgetPassword?: boolean
  }

export const InputPassword = ({
  name,
  label,
  className,
  container,
  error,
  showLinkForgetPassword = false,
  withoutError = false,
  ...rest
}: InputPasswordProps) => {
  const [field, meta] = useField<string>(name)

  return (
    <div {...container}>
      <div className="flex items-center justify-between">
        {label}
        {showLinkForgetPassword && (
          <Link href="/reset-password" className="cursor-pointer text-orange">
            Esqueci minha senha?
          </Link>
        )}
      </div>
      <input
        type="password"
        className={classNames(styles.input, className, {
          [styles.error]: meta.error && meta.touched
        })}
        {...field}
        {...rest}
      />
      {!withoutError && (
        <FieldError touched={meta.touched} error={meta.error} {...error} />
      )}
    </div>
  )
}
